/*
    Shared enum
*/
export enum EventName {
  /* General events  */
  BUTTON_CLICKED = 'Button_Clicked',
  FILTER_CLICKED = 'Filter_Clicked',
  PAGE_VIEWED = 'Page_Viewed',
  SECTION_VIEWED = 'Section_Viewed',

  /* Accredited network specific events  */
  NOT_FOUND_ACCREDITED_ESTABLISHMENTS = 'Not_Found_Accredited_Establishments',
  NOT_FOUND_ESTABLISHMENTS = 'Not_Found_Establishments',

  /* Lead Generation specific events  */
  START_SIMULATION_CLICKED = 'Start_Simulation_Clicked',

  /* Simulation Result specific events */
  OFFER_BUTTON_CLICKED = 'Offer_Button_Clicked',

  /* Simulator specific events */
  SIMULATION_SENT = 'Simulation_Sent',
  STEP_BUTTON_CLICKED = 'Step_Button_Clicked'
}

export enum ButtonType {
  ACTION = 'action',
  DOWNLOAD = 'download',
  NEW_PAGE = 'new_page',
  SHARE = 'share'
}

/*
    Base events props
*/
export interface EventBaseProps {
  eventName: EventName
}

export interface PageViewedBaseProps extends EventBaseProps {
  pageTitle: string
  pageReferrer: string
}

export interface ButtonClickedBaseProps extends EventBaseProps {
  buttonName: string
  buttonType: ButtonType
}

export interface FilterClickedBaseProps extends EventBaseProps {
  filterName: string
  filterValue: string
}

export interface SectionViewedBaseProps extends EventBaseProps {
  pageTitle: string
}
